import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import Button from '../components/Button/Button'
import InputField from '../components/InputField/InputField'
import Spoiler from '../components/Spoiler/Spoiler'
import { useAppSelector } from '../redux/hooks'
import { receiverSchema } from '../schema/schema'
import { CartItem } from '../types/types'

import './styles/Order.scss'

interface Receiver {
    name: string
    surname: string
    email: string
    company: string
    address: string
    city: string
    phone: string
}

interface IOrder {
    products: CartItem[]
    receiver: Receiver
}

const Order = () => {
    const [emptyEmail, setEmptyEmail] = useState(false)
    const auth = useAppSelector((state) => state.authReducer)
    const cart = useAppSelector((state) => state.cartReducer)
    const handleOrder = (receiver: Receiver) => {
        if(receiver.email.length < 1){
            if(!!auth.user){
                receiver.email = auth.user.email
            } else {
                setEmptyEmail(true)
                return
            }
        }
        setEmptyEmail(false)
        const order: IOrder = {products: cart, receiver: receiver}
        console.log(order) // SENT TO BACKEND
    }
    const { register, handleSubmit, formState:{ errors } } = useForm<Receiver>({
        resolver: yupResolver(receiverSchema)
    });

  return (
    <main>
        <Breadcrumbs/>
        <section>
            <div className="order">
                <div className="container">
                    <div className="order-header">
                        <h1>Checkout</h1>
                        {!!auth.user ? <></> : <Button variant="outlined">Sign in</Button>}
                    </div>
                    <div className="order-wrapper">
                        <div className="order-form">
                            <h2 className="order-form__title">Shipping Address</h2>
                            <form onSubmit={handleSubmit(handleOrder)}>
                                {!!auth.user ? <></> : 
                                    <div className='unauthenticated'>
                                        <InputField type="email" label="Email Address" className={emptyEmail ? 'error' : ''} {...register('email')}/>
                                        <p>You can create account after checkout.</p>
                                    </div>}
                                <InputField label="First Name" className={!!errors.name ? 'error' : ''} required {...register('name')}/>
                                <InputField label="Last Name" className={!!errors.surname ? 'error' : ''} required {...register('surname')}/>
                                <InputField label="Company" className={!!errors.company ? 'error' : ''} required {...register('company')}/>
                                <InputField label="Street Address" className={!!errors.address ? 'error' : ''}  required {...register('address')}/>
                                <InputField label="City" className={!!errors.city ? 'error' : ''}  required {...register('city')}/>
                                <InputField label="Phone Number" className={!!errors.phone ? 'error' : ''}  required {...register('phone')}/>
                                <div className="delivery">
                                    <div className="delivery-item">
                                        <p className='delivery-item__title'>Standart rate</p>
                                        <div className="delivery-item-content">
                                            <div className="delivery-item-input">
                                                <input type="radio" checked name="delivery" id="delivery_1" />
                                                <label htmlFor="delivery_1"><span></span> Price may vary depending on the item/destination. Shop Staff will contact you.</label>
                                            </div>
                                            <p className="delivery-item__price">$21</p>
                                        </div>
                                    </div>
                                    <div className="delivery-item">
                                        <p className='delivery-item__title'>Pickup from store</p>
                                        <div className="delivery-item-content">
                                            <div className="delivery-item-input">
                                                <input type="radio" name="delivery" id="delivery_2" />
                                                <label htmlFor="delivery_2"><span></span> 1234 Street Adress City Address, 1234</label>
                                            </div>
                                            <p className="delivery-item__price">$0</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="order-button">
                                    <Button variant='filled' type='submit'>Order</Button>
                                </div>
                            </form>
                        </div>
                        <div className="order-list">
                            <h2>Order Summary</h2>
                            <Spoiler title={`${cart.length} Items in Cart`}>
                                {cart.map(item => {
                                    return (<div className='order-item' key={item.id}>
                                        <div className="order-item__image">
                                            <img src={item.product.images[0]} alt="" />
                                        </div>
                                        <div className="order-item-info">
                                            <p>{item.product.title}</p>
                                            <div className="order-item-additional">
                                                <span className="order-item-additional__qty">Qty {item.count}</span>
                                                <span className="order-item-additional__price">${item.product.price * item.count}</span>
                                            </div>
                                        </div>
                                    </div>)
                                })}
                            </Spoiler>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
  )
}

export default Order